module.exports = __webpack_public_path__ + "static/DSC_9437-3474b84e0aceaca671a8c07382be417c.jpg";